import * as messageDB from "./Message";
import { DB_NAME, DB_VERSION, setupSchema } from "./Schema";
import { openDB } from "./Utils";

// Optional: Expose init to force DB creation on app start
export async function initDB() {
  await openDB(DB_NAME, DB_VERSION, (db) => {
    console.log("[IndexedDB] Initialized or upgraded");
    setupSchema(db);
  });
}

export const Messages = messageDB;